<div *ngIf="!hideMap" #mapContainer>
  <curbnturf-here-map
    #hereMap
    [lat]="coordinates.lat"
    [lon]="coordinates.lon"
    [zoom]="13"
    [mapHostPoints]="points"
    [mapBoondockPoints]="boondockPoints"
    [mapPoiPoints]="activities"
    [disableControls]="true"
    [showCurrentLocation]="false"
  >
  </curbnturf-here-map>
</div>
